<template>
  <div class="form-detail-loader">
    <div class="skeleton-back-btn" />

    <div class="skeleton-layout">
      <div class="skeleton-card">
        <div class="skeleton-header">
          <div class="skeleton-icon" />
          <div class="skeleton-header-text">
            <div class="skeleton-line skeleton-line--title" />
            <div class="skeleton-line skeleton-line--subtitle" />
          </div>
          <div class="skeleton-line skeleton-line--badge" />
        </div>

        <div class="skeleton-fields">
          <div v-for="i in 6" :key="i" class="skeleton-field">
            <div class="skeleton-line skeleton-line--label" />
            <div class="skeleton-line skeleton-line--input" />
          </div>
        </div>

        <div class="skeleton-footer">
          <div class="skeleton-line skeleton-line--btn" />
          <div class="skeleton-line skeleton-line--btn skeleton-line--btn-primary" />
        </div>
      </div>

      <div class="skeleton-sidebar">
        <div class="skeleton-card">
          <div class="skeleton-sidebar-title" />
          <div v-for="i in 3" :key="i" class="skeleton-sidebar-row" />
        </div>
        <div class="skeleton-card">
          <div class="skeleton-sidebar-title" />
          <div class="skeleton-line skeleton-line--help-text" />
          <div class="skeleton-line skeleton-line--help-email" />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.form-detail-loader {
  @apply space-y-5;
}

.skeleton-back-btn {
  @apply h-5 w-32 rounded;
}

.skeleton-layout {
  @apply grid grid-cols-1 lg:grid-cols-3 gap-6 items-start;
}

.skeleton-card {
  @apply bg-white dark:bg-gray-800
         rounded-2xl border border-gray-100 dark:border-gray-700/60
         overflow-hidden p-6;
}

.skeleton-card:nth-child(1) {
  @apply lg:col-span-2;
}

.skeleton-header {
  @apply flex items-start gap-4 pb-6 border-b border-gray-100 dark:border-gray-700/40;
}

.skeleton-icon {
  @apply h-16 w-16 rounded-2xl flex-shrink-0;
}

.skeleton-header-text {
  @apply flex-1 space-y-2;
}

.skeleton-line {
  @apply rounded-lg animate-pulse;
}

.skeleton-line--title {
  @apply h-6 w-56;
}

.skeleton-line--subtitle {
  @apply h-4 w-96;
}

.skeleton-line--badge {
  @apply h-6 w-16 rounded-full flex-shrink-0;
}

.skeleton-fields {
  @apply space-y-5 py-5;
}

.skeleton-field {
  @apply space-y-2;
}

.skeleton-line--label {
  @apply h-4 w-24;
}

.skeleton-line--input {
  @apply h-11 rounded-xl;
}

.skeleton-footer {
  @apply flex items-center justify-end gap-3
         pt-5 border-t border-gray-100 dark:border-gray-700/50;
}

.skeleton-line--btn {
  @apply h-10 w-20 rounded-xl;
}

.skeleton-line--btn-primary {
  @apply w-32;
}

.skeleton-sidebar {
  @apply space-y-4;
}

.skeleton-sidebar .skeleton-card {
  @apply lg:col-span-1 p-5;
}

.skeleton-sidebar-title {
  @apply h-5 w-32 rounded mb-4 pb-3
         border-b border-gray-100 dark:border-gray-700/40;
}

.skeleton-sidebar-row {
  @apply h-12 rounded-lg mt-3;
}

.skeleton-sidebar-row:first-of-type {
  @apply mt-0;
}

.skeleton-line--help-text {
  @apply h-4 w-full;
  margin-bottom: 8px;
}

.skeleton-line--help-email {
  @apply h-4 w-40 mt-3;
}

.skeleton-back-btn,
.skeleton-icon,
.skeleton-line {
  @apply bg-gray-100 dark:bg-gray-700/50;
}
</style>
